import { connect } from 'react-redux';
import { PowerSupply as Component } from './PowerSupply';
import {
  pushInteractions,
  setPowerSupplyAnodeConnected,
  setPowerSupplyCathodeConnected,
  setModal,
  showModal,
  createPowerSupply,
  hideAllControls,

  toggleModalPs,
  togglePowerPs,
  setTimerPs,
  setVoltagePs,
  setCurrentPs,
  onStartPowerSupplyPs,
  onStopPowerSupplyPs,
  animationPlaybackCompletePs,
  onDropWirePs,
  
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("powerSupply") &&
    state.notebook.protocolSection.scene.apparatus.powerSupply.some(
      powerSupply => powerSupply.id === ownProps.id
    )
  ) {
    return {
      id: ownProps.id,
      anodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].anodeConnected,
      cathodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].cathodeConnected,

      modalOpen: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].modalOpen,
      power: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].power,
      pluggedIn: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].pluggedIn,

      settings: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].settings,
      running: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].running,
      completed: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].completed,
      cables: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].cables,
      
      controlsVisible: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id - 1].controlsVisible,
      interactionProps: {
        gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    setPowerSupplyAnodeConnected: (data) => {
      dispatch(setPowerSupplyAnodeConnected(data))
    },
    setPowerSupplyCathodeConnected: (data) => {
      dispatch(    setPowerSupplyCathodeConnected(data))
    },
    setModal: (data) => {
      dispatch(    setModal(data))
    },
    showModal: (data) => {
      dispatch(    showModal(data))
    },
    createPowerSupply: (data) => {
      dispatch(    createPowerSupply(data))
    },

    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },

    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },

    toggleModalPs: (data) => {
      dispatch(toggleModalPs(data))
   },
   togglePowerPs: (data) => {
      dispatch(togglePowerPs(data))
   },
   setTimerPs: (data) => {
      dispatch(setTimerPs(data))
   },
   setVoltagePs: (data) => {
      dispatch(setVoltagePs(data))
   },
   setCurrentPs: (data) => {
      dispatch(setCurrentPs(data))
   },
   onStartPowerSupplyPs: () => {
      dispatch(onStartPowerSupplyPs())
   },
   onStopPowerSupplyPs: () => {
      dispatch(onStopPowerSupplyPs())
   },
   animationPlaybackCompletePs: () => {
      dispatch(animationPlaybackCompletePs())
   },
   onDropWirePs: (data) => {
      dispatch(onDropWirePs(data))
   },

  };
}

export const PowerSupply = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
